export default __webpack_public_path__ + "static/media/bk.685084af.jpg";